import { gql } from '@apollo/client';
import { NEW_ACTION } from '../fragments/action';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_ACTION y UPDATE_ACTION eliminados (Bloque C-Limpieza 2026-05-08):
// sustituidos por SAVE_ACTION atómica.
//
// UPDATE_ACTION_RELATIONSHIPS sigue VIVA hasta Fase 2 — gestiona campos M:N
// (operatorIds, vehicleOccupantIds, workVehicleIds) que SAVE_ACTION no
// incluye en SaveActionInput. Comentario schema Bloque C-5.3 explícito:
// "saveAction cubre SOLO campos Tipo B + Tipo C denormalizados".
export const UPDATE_ACTION_RELATIONSHIPS = gql`
  mutation UpdateActionRelationships($input: UpdateActionRelationships!) {
    updateActionRelationships(input: $input) {
      ...NewAction
    }
  }
  ${NEW_ACTION}
`;

export const CONNECT_MANY_USERS_TO_ACTION = gql`
  mutation connectManyUsers($input: ActionAndUsersIDs!) {
    connectManyUsers(input: $input) {
      userIDs
    }
  }
`;

export const DISCONNECT_MANY_USERS_FROM_ACTION = gql`
  mutation disconnectManyUsers($input: ActionAndUsersIDs!) {
    disconnectManyUsers(input: $input) {
      userIDs
    }
  }
`;

export const UPDATE_MANY_VEHICLE_OCCUPANTS_ACTION = gql`
  mutation updateManyVehicleOccupantsAction(
    $input: [UpdatedVehicleOccupantsItems!]!
  ) {
    updateManyVehicleOccupantsAction(input: $input) {
      userDriverIDs
    }
  }
`;

export const DELETE_MANY_VEHICLE_OCCUPANTS_ACTION = gql`
  mutation deleteManyVehicleOccupantsAction($ids: [ID!]!) {
    deleteManyVehicleOccupantsAction(ids: $ids) {
      id
      userDriverIDs
    }
  }
`;

export const DELETE_ACTION_BY_ID = gql`
  mutation deleteAction($id: ID!) {
    deleteAction(id: $id) {
      ...NewAction
    }
  }
  ${NEW_ACTION}
`;

/**
 * Endpoint unificado que reemplaza CREATE_NEW_ORDER + CREATE_NEW_ACTION +
 * UPDATE_ORDER + UPDATE_ORDER_RELATIONSHIPS del flujo NewAction.
 *
 * La response devuelve Order + Action completos (via fragments NEW_ORDER +
 * NEW_ACTION) para que Apollo normalice ambas celdas en el mismo tick. Ver
 * PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const SAVE_ACTION = gql`
  mutation SaveAction($input: SaveActionInput!) {
    saveAction(input: $input) {
      order {
        ...NewOrder
      }
      action {
        ...NewAction
      }
      allActionsValidated
      parentOrderId
    }
  }
  ${NEW_ORDER}
  ${NEW_ACTION}
`;
